<template>
  <div
    class="wrapper-1 pa-2 d-flex justify-space-evenly align-center h-50"
    :class="computedFileDirActionsWrapper"
  >
    <!--GENERATE REPORT-->
    <Button
      v-if="isShowFilteringReport"
      :clickAction="showReportClicked"
      :disabled="isShowReportDisabled"
      btnType="grey"
      :text="screenType === 'desktop' ? $t('View Filtering Report') : $t('View Report')"
      fontSize="16"
      :height="screenType === 'desktop' ? 35 : 25"
      :width="screenType === 'desktop' ? 220 : 90"
      :btnSize="screenType === 'desktop' ? '' : 'medium'"
    />
    <!-- <v-btn
      v-if="isShowFilteringReport && screenType !== 'desktop'"
      @click="showReportClicked"
      :disabled="isShowReportDisabled"
      fab
      :small="accessibility.fontSize === 1"
      outlined
      color="grey"
      aria-label="Filtering Report selected"
    >
      <v-icon :large="accessibility.fontSize > 1"> mdi-file </v-icon>
    </v-btn> -->

    <!--DELETE FILES-->
    <!-- v-if="screenType === 'desktop'" -->
    <Button
      :clickAction="deleteFilesClicked"
      :disabled="isDeleteDownloadFilesDisabled"
      btnType="grey"
      :text="screenType === 'desktop' ? $t('Delete Selected') : $t('Delete')"
      fontSize="16"
      :height="screenType === 'desktop' ? 35 : 25"
     :width="screenType === 'desktop' ? 220 : 60"
      :btnSize="screenType === 'desktop' ? '' : 'medium'"
    />
    <!-- <v-btn
      v-else
      @click="deleteFilesClicked"
      :disabled="isDeleteDownloadFilesDisabled"
      fab
      :small="accessibility.fontSize === 1"
      outlined
      color="red"
      aria-label="Delete selected"
    >
      <v-icon :large="accessibility.fontSize > 1"> mdi-delete </v-icon>
    </v-btn> -->

    <!--DOWNLOAD FILES-->
    <Button
      v-if="loggedUser.license !== 'SFTP'"
      :clickAction="downloadFilesClicked"
      :disabled="isDownloadFilesDisabled"
      :text=" screenType === 'desktop' ? $t('Download Selected') : $t('Download')"
      fontSize="16"
      :height="screenType === 'desktop' ? 35 : 25"
      :width="screenType === 'desktop' ? 220 : 80"
      :btnSize="screenType === 'desktop' ? '' : 'medium'"
      />
      <!-- <v-btn
      v-if="loggedUser.license !== 'SFTP' && screenType !== 'desktop'"
      @click="downloadFilesClicked"
      :disabled="isDeleteDownloadFilesDisabled"
      fab
      :small="accessibility.fontSize === 1"
      outlined
      color="primary"
      aria-label="Download files selected"
    >
      <v-icon :large="accessibility.fontSize > 1"> mdi-download </v-icon>
    </v-btn> -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

//Base components
import Button from '@/components/BaseComponents/Button/Button.vue'

export default {
  name: 'FileDirActions',
  props: {
    selectedDirFiles: Array,
    showReportClicked: Function,
    downloadFilesClicked: Function,
    deleteFilesClicked: Function,
    screenType: String,
  },

  components: { Button },

  computed: {
    ...mapGetters(['loggedUser', 'accessibility']),

    computedFileDirActionsWrapper() {
      const width = this.$vuetify.breakpoint.width
      if (this.accessibility.fontSize === 3 && width > 1024 && width < 1180) {
        return 'accessibility-big-font-size'
      }
      return ''
    },
    isShowFilteringReport() {
      //casual can't see report
      if (this.loggedUser.role === 'Casual') return false

      //if the logged user dosen't have the option to see report
      if (!this.loggedUser.isAllowReport) return false

      return true
    },

    isShowReportDisabled() {
      if (!this.selectedDirFiles.length) return true
      //if all the files that the user selected dosen't have historyId then there is no option to report
      if (this.selectedDirFiles.every(el => el.status && !el.historyId))
        return true
      return false
    },

    isDownloadFilesDisabled() {
      if (!this.selectedDirFiles.length) return true
      let sumOfSize = 0

      this.selectedDirFiles.forEach(dirFlie => (sumOfSize += dirFlie.size))

      if (sumOfSize === 0) return true
      return false
    },
    isDeleteDownloadFilesDisabled() {
      if (!this.selectedDirFiles.length) return true
      // let sumOfSize = 0
      // this.selectedDirFiles.forEach(dirFlie => (sumOfSize += dirFlie.size))
      // if (sumOfSize === 0) return true
      return false
    },
  },
}
</script>

<style scoped>
.accessibility-big-font-size {
  height: 100px !important;
  flex-wrap: wrap;
}
</style>
